var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":(_vm.size + "px"),"height":(_vm.size + "px")}},[_c('circle',{attrs:{"cx":_vm.size/2,"cy":_vm.size/2,"fill":_vm.fill,"r":_vm.size/2}})])}
var staticRenderFns = []

export { render, staticRenderFns }